import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IGeneralText } from 'src/app/core/interfaces/generalText.interface';
import { TextService } from 'src/app/core/service/text.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import {
  noWhitespaceValidator,
  trimStringValues,
} from 'src/app/services/common.service';
import CONSTANTS from 'src/@utility/constants';
import { Transformation } from 'src/@utility/model-transformation';
import { UserService } from 'src/app/services/user.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import constants from 'src/@utility/constants';
@Component({
  selector: 'app-entity-form',
  templateUrl: './entity-form.component.html',
  styleUrls: ['./entity-form.component.scss'],
})
export class EntityFormComponent implements OnInit, OnChanges {
  @Input() uniqueId;
  @Input() config;
  @Input() fields;
  @Input() data;
  @Input() postData: any = {};
  @Input() isNew;
  @Input() visible;
  @Input() readonly;
  @Output() onToggle = new EventEmitter();
  @Output() onSave = new EventEmitter();
  constants = constants;
  @Output() onFormInit = new EventEmitter<FormGroup>();

  @Input() transformModelFn: {
    forward: (args) => any;
    backward: (args) => any;
  };

  entityForm;
  supportedValidations = {
    min: Validators.min,
    max: Validators.max,
    required: Validators.required,
    requiredTrue: Validators.requiredTrue,
    email: Validators.pattern(CONSTANTS.emailRegex),
    phone: Validators.pattern(CONSTANTS.phoneNumberRegex),
    genderSa: Validators.pattern(CONSTANTS.genderRegex),
    noSpaceStart: Validators.pattern(CONSTANTS.noSpaceStart),
    minLength: Validators.minLength,
    maxLength: Validators.maxLength,
    pattern: Validators.pattern,
    nullValidator: Validators.nullValidator,
    compose: Validators.compose,
    composeAsync: Validators.composeAsync,
    noWhiteSpace: noWhitespaceValidator,
    indianPhoneNumber: Validators.pattern('^\\+91 [0-9]{10}$'),
    saudiPhoneNumber: Validators.pattern('^\\+966 [0-9]{9}$'),
  };
  files: any[] = [];
  maximized = false;
  formSubmitted = false;
  generalTexts: IGeneralText = {
    saveButton: { labelId: 'L_SAVE' },
    cancelButton: { labelId: 'L_CANCEL' },
    titleText: { labelId: 'L_DETAILS' },
    successMsg: { labelId: 'L_SUCCESSFUL' },
    recordUpdate: { labelId: 'L_RECORD_UPDATED' },
    created: { labelId: 'L_CREATED' },
    error: { labelId: 'L_ERRORTITLE' },
    warn: { labelId: 'L_WARNING' },
    details: { labelId: 'L_MANDATORY_MSG' },
    duplicateRecord: { labelId: 'M_MODULE_EXIST' },
    choose: { labelId: 'L_CHOOSE' },
    invalidUser: { labelId: 'L_INVALID_USER' },
  };

  constructor(
    private restApi: RequestService,
    private commonMessageService: CommonMessageService,
    private fb: FormBuilder,
    private textService: TextService,
    private userService: UserService
  ) {
    this.filterValidator = this.filterValidator.bind(this);
    this.mapValidator = this.mapValidator.bind(this);
  }

  ngOnInit() {
    this.entityForm = this.fb.group({});
    this.formInit();
    this.translateText();
  }

  translateText() {
    this.textService.convert(this.generalTexts).subscribe((texts) => {
      this.generalTexts = texts;
    });
  }

  ngOnChanges() {
    this.formInit();
  }

  formInit() {
    const controls = this.fields.reduce((ctrls, single) => {
      ctrls[single.field] = [
        {
          value: this.isNew ? single.value : this.data[single.field],
          disabled: single.disabled || (!this.isNew && single.editDisabled),
        },
        single.validations?.filter(this.filterValidator).map(this.mapValidator),
      ];

      return ctrls;
    }, {});

    this.entityForm = this.fb.group(controls);

    const keys = Object.keys(controls);
    for (const key of keys) {
      const value = controls[key][0].value;
      if (
        typeof value === 'string' &&
        /^data:([A-Za-z]+\/[A-Za-z]+);base64,([A-Za-z0-9+/]+={0,2})$/.test(
          value.split('|')[1]
        )
      ) {
        this.convertBase64ToFile(value.split('|')[1], value.split('|')[0], key);
      }
    }

    if (this.readonly) {
      this.entityForm.disable();
    }

    this.onFormInit.emit(this.entityForm);
  }

  processSaveData(record) {
    const newrecord = this.postData || {};

    if (this.config.softDelete) {
      newrecord.isEnabled = true;
    }

    this.fields.forEach((col) => {
      const optionValue = col.optionValue || 'value';
      switch (col.type) {
        case 'user-auto-select':
        case 'select':
          newrecord[col.field] =
            !col.expectedObject && record[col.field]
              ? record[col.field][optionValue]
              : record[col.field];
          break;
        case 'checkbox':
          newrecord[col.field] =
            col.single && Array.isArray(record[col.field])
              ? record[col.field][0]
              : record[col.field];
          break;

        default:
          newrecord[col.field] = record[col.field];
      }
      if (col.boolean) {
        newrecord[col.field] = !!newrecord[col.field];
      }
    });

    if (this.config.objToStr.length) {
      this.config.objToStr.map((m) => {
        newrecord[m.field] =
          typeof record[m.field] === 'object'
            ? newrecord[m.field]?.[m.key]
            : newrecord[m.field];
      });
    }
    return newrecord;
  }

  onImageUpload(e, field) {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;
      this.entityForm
        .get(field)
        .setValue(`${e.currentFiles[0].name}|${base64String}` || '');
    };
    reader.readAsDataURL(e.currentFiles[0] || null);
  }

  onImageClear(field) {
    this.entityForm.get(field).setValue(null);
  }

  convertBase64ToFile(base64String: string, fileName: string, field: string) {
    const byteCharacters = atob(base64String.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const file = new File([blob], fileName, {
      type: 'application/octet-stream',
    });
    this.files = [file];
    this.entityForm.get(field).setValue(`${fileName}|${base64String}`);
    this.entityForm.get(field).updateValueAndValidity();
  }

  saveData(): void {
    trimStringValues(this.entityForm);

    if (this.entityForm.invalid) {
      this.commonMessageService.warn();
      return;
    }
    if (this.formSubmitted) {
      return;
    }
    this.formSubmitted = true;
    let invalidUser = true;
    this.fields.find((col) => {
      if (col.type === 'user-auto-select' && col.asyncType === 'user') {
        const field = this.entityForm.get(col.field);
        if (field.value == null || field.value?.id == null) {
          invalidUser = false;
          field.setErrors({ invalid: true });
        }
      }
    });

    if (!invalidUser) {
      this.commonMessageService.warn(this.generalTexts.invalidUser.label);
      return;
    }

    const formData = this.entityForm.getRawValue();
    let newRecord = this.processSaveData(formData);

    if (this.config.transformModel) {
      newRecord = this.transformModelFn.forward(newRecord);
    }
    if (!this.isNew) {
      this.restApi
        .request('PUT', `${this.config.url}/${this.data.id}`, {
          ...this.data,
          ...newRecord,
        })
        .pipe(catchError(this.handleError.bind(this)))
        .subscribe((response: any) => {
          this.onSave.emit({ data: response });
          this.commonMessageService.success('update');
          this.hideDialog();
          this.formSubmitted = false;
          this.setDefaultData();
        });
    } else {
      this.restApi
        .request('POST', this.config.url || '', newRecord)
        .pipe(catchError(this.handleError.bind(this)))
        .subscribe((response: any) => {
          this.onSave.emit({ data: response });
          this.commonMessageService.success('add');
          this.hideDialog();
          this.formSubmitted = false;
          this.setDefaultData();
        });
    }
  }

  handleError(error): any {
    let errorMessage: string;
    if (error.error && error.error.status < 500) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
      const errorTextSub = this.textService
        .convert({ labelId: error.error.errorKey })
        .subscribe((err) => {
          this.commonMessageService.error('add', err.label);
        });

      setTimeout(() => {
        errorTextSub?.unsubscribe();
      }, 2000);
    } else {
      // server-side error
      if (error.includes('409')) {
        this.commonMessageService.error(
          'add',
          this.generalTexts.duplicateRecord.label
        );
      }
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    this.formSubmitted = false;
    return throwError(errorMessage);
  }

  setDefaultData() {
    const data = this.fields
      .filter((field) => field.type === 'select')
      .reduce((accField, entity) => {
        accField[entity.field] = entity.source[0];
        return accField;
      }, {});

    this.fields
      .filter((field) => field.default !== undefined)
      .reduce((accField, entity) => {
        accField[entity.field] = entity.default;
        return accField;
      }, data);

    this.entityForm.patchValue(data);
  }

  handleMaximize(data: { maximized: boolean }): void {
    this.maximized = data.maximized;
  }

  handleDialogShow(): void {
    this.maximized = false;
    this.onToggle.emit({ visible: true });
  }
  hideDialog(): void {
    this.visible = false;
    this.isNew = false;
    this.onToggle.emit({ visible: false });
  }

  controlClass(col): string {
    if (col.type === 'select-list') {
      return 'p-col-12';
    }
    return (this.maximized ? 'p-col-6 p-lg-4 p-xl-3 ' : 'p-col-12 ') + col.ui;
  }

  filterValidator(validatorObj) {
    return this.supportedValidations[validatorObj.name];
  }

  mapValidator(validatorObj) {
    let validatorFn;
    const validator = validatorObj.validator;
    validatorFn = this.supportedValidations[validator];
    if (validatorObj.args) {
      validatorFn = validatorFn.apply(null, validatorObj.args);
    }
    return validatorFn;
  }

  getControl(name) {
    return this.entityForm.controls[name];
  }

  onColorChange(value, field) {
    this.entityForm.get(field).setValue(value);
  }

  searchUser(ev: any, control) {
    this.userService.findUsers(ev.query).subscribe((res) => {
      this.fields.find((s) => s.name === control).source = res.body.map((s) =>
        Transformation.user(s)
      );
    });
  }
}
